module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('p', [_vm._v("Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-feeds"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Ongoing Activities")]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Olu Jane Stores")]), _vm._v(" Commented on a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("5 mins ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lami Fashion Store")]), _vm._v(" Has posted a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("an hour ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trish Hairs")]), _vm._v(" Liked friend's product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("4 hours ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LuluBeads Crafts")]), _vm._v(" has shared a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("a day ago")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tradefair Talks")]), _vm._v(" "), _c('ul', {
    staticClass: "online-users list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Cynthia Belonwu"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jubril Sani"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sandra Oseni"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Titilo Bass"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jayden Ajibade"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Nonso Obi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Efiong Dun"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Chika Nnabi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Bolaji Adewale"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf949578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/leftsidebar.vue
// module id = 273
// module chunks = 0